import { useEffect, useState } from "react";
import LoadingOverlay from "../../components/loadingOverlay";
import ActivityCard from "./activityCard";
import { API_BASE } from "../../config/apiConfig";

export default function UpcomingTab() {
  const token = sessionStorage.getItem("access_token");

  const [loading, setLoading] = useState(false);
  const [activities, setActivities] = useState([]);

  useEffect(() => {
    loadUpcoming();
  }, []);

  async function loadUpcoming() {
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/player-upcoming-activities`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (data.success) setActivities(data.activities);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <LoadingOverlay show={loading} />

      <div className="grid gap-4">
        {activities.map((a, idx) => (
          <ActivityCard key={a.id} activity={a} idx={idx} />
        ))}

        {activities.length === 0 && (
          <p className="text-center text-gray-500">No upcoming activities.</p>
        )}
      </div>
    </>
  );
}
